<div class="ui grid segment backgroundcolor" [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 64) + 'px','margin-top': '0px','margin-bottom': '0px','padding-left':'0px','padding-right':'0px'}">
    <div class="ui column" style="border-style:groove;overflow:auto;background-color:white"  [ngStyle]="{'width': (this.tournamentsService.Page_Window_Width - 505-39) + 'px','height': (this.tournamentsService.Page_Window_Height - 64) + 'px','padding-top': '0px','padding-bottom': '0px','padding-left':'0px','padding-right': '5px'}">


            <table id="slipdetail_table"  >
                <tr id="slipdetail_table_1tr" >

                    <td style="width:2%"></td>
                    <td style="width:18%">
                        <span class="slipdetail_span" style="float:left;font-weight:bold;font-size:15px">{{"EVENT" | t}}</span>
                    </td>
                  <td style="width:5%">

                  </td>
                    <td style="width:10%">
                        <span class="slipdetail_span">{{"TYPE" | t}}</span>
                    </td>
                    <td style="width:7%">
                        <span class="slipdetail_span">{{"SELECTION" | t}}</span>
                    </td>
                    <td style="width:7%">
                        <span class="slipdetail_span">{{"ODDS" | t}}</span>
                    </td>
                    <td style="width:6%">
                        <span class="slipdetail_span">{{"ActivOdd" | t}}</span>
                    </td>
                    <td style="width:10%">
                        <span class="slipdetail_span">{{"SCORE_PLACE_BET" | t}} </span>
                    </td>
                    <td style="width:10%">
                        <span class="slipdetail_span">{{"CURRENT_SCORE" | t}}D</span>
                    </td>
                    <td style="width:8%">
                        <span class="slipdetail_span">{{"FINAL_SCORE_HALFTIME" | t}}</span>
                    </td>
                  <td style="width:16%">
                    <i class="info circle large icon"></i>
                  </td>
                </tr>
              <ng-container *ngFor="let slip of this.tournamentsService.SlipDetailList_Terminal;let i = index;">

                <tr id="slipdetail_table_2tr" class="{{this._uiHelper.terminalConfig.IsJacktimeActive ? 'd' : 'disabled' }}"  style="">
                  <td style="width:2%;background-color:#cbc4be">
                    <div style="display: flex;align-items: center;justify-content: center;">
                      <span *ngIf="slip?.Banko == 1" style="font-weight: bold;">B</span>
                      <button *ngIf="this.livetracker"
                              class="ui icon button iconStatisticButton"
                              style="margin:0"
                              (click)="OpenLiveTrackerModal(slip)">
                        <span><i class="tv icon" style="color: black"></i></span>
                      </button>
                    </div>
                  </td>
                  <td style="width:18%;text-align:left;background-color:gainsboro;filter: none !important">
                    <span class="slipdetail_span" style="display: flex;flex: 1">

                      <span style="flex: 1">{{slip?.HomeTeam}}</span>

                      <!-- BET REASON HOME -->
                      <ng-container *ngIf="slip?.BetStopReasonHome != ''">
                          <span class="cashout-betstopreason" [ngClass]="slip?.BetStopReasonColor">
                            {{slip?.BetStopReasonHome}}
                          </span>
                       </ng-container>
                      <!-- BET REASON HOME -->

                    </span>
                    <!-- <br />-->

                    <span class="slipdetail_span" style="display: flex;flex: 1">
                       <span style="flex: 1">{{slip?.AwayTeam}}</span>

                      <!-- BET REASON AWAY -->
                       <ng-container *ngIf="slip?.BetStopReasonAway != ''">
                          <span class="cashout-betstopreason" [ngClass]="slip?.BetStopReasonColor">
                             {{slip?.BetStopReasonAway}}
                          </span>
                       </ng-container>
                      <!-- BET REASON AWAY -->

                    </span>
                  </td>
                  <td style="width:5%;text-align:center;background-color:gainsboro">
                    {{slip.EventDateTime}}
                  </td>
                  <td style="background-color:#cbc4be;width:10%">
                    <span class="slipdetail_span">{{slip?.OddsType}} {{slip?.SpecialBetValue}} </span>
                  </td>
                  <td style="width:7%;height:28px;background-color:gainsboro;filter: none !important;">
                    <div
                      [ngStyle]="{'background-color': slip?.ResultStatus}"
                      style="height: 30px;color: white;border-radius: 5px;font-weight: bold">
                      <span style="position:relative;top:2px">
                        {{slip?.Outcomes}}
                      </span>
                    </div>
                  </td>
                  <td style="background-color:#cbc4be;width:7%">

                    <ng-container *ngIf="this._uiHelper.terminalConfig.IsJacktimeActive; else JacktimeFalseTemplate">
                      <span  *ngIf="slip?.IsActive" class="slipdetail_span">{{slip?.OddValue}}</span>

                    </ng-container>
                    <ng-template #JacktimeFalseTemplate>
                      <span  *ngIf="slip?.IsActive" class="slipdetail_span">{{slip?.OddValue}}</span><img *ngIf="!slip?.IsActive" style="height: 25px; width: 25px; object-fit: contain" src="Images/lock.png">

                    </ng-template>
                  </td>
                  <td style="width:6%;background-color:gainsboro;color: #21ba45;font-weight: 800;filter: none !important">
                    <span class="slipdetail_span">{{slip?.BetPlacement}}</span>
                  </td>
                  <td style="background-color:#cbc4be;width:10%">
                    <span class="slipdetail_span">{{slip?.SlipScore}} </span>
                  </td>
                  <td style="background-color:gainsboro;width:10%">
                    <span class="slipdetail_span">
                      <ng-container *ngIf="slip?.CurrentScore == '-'">
                        {{slip.EvenDate}}
                      </ng-container>
                      <ng-container *ngIf="slip?.CurrentScore != '-'">
                        {{slip?.CurrentScore}}
                      </ng-container>
                    </span>
                  </td>
                  <td style="width:8%;background-color:#cbc4be;">
                    <span class="slipdetail_span">{{slip?.FinalHalfScore}}</span>
                  </td>

                  <td style="width:7%;height:28px;background-color:gainsboro;filter: none !important;">
                    <div
                      [ngStyle]="{'background-color': slip?.ResultStatus}"
                      style="height: 30px;color: white;border-radius: 5px;font-weight: bold">
                      <span style="position:relative;top:2px">
                       {{slip?.State}}
                      </span>
                    </div>
                  </td>
                </tr>

              </ng-container>

<!--              <ng-container *ngIf="checkLockStatus(slip) != ''">-->
<!--                <tr>-->
<!--                  <td colspan="1"  style="background-color:#cbc4be;text-align: center"><i class="info circle icon"></i></td>-->
<!--                  <td colspan="8" style="background-color:gainsboro;text-align: left;font-weight: bold;font-size: 16px;color: #78797a">{{checkLockStatus(slip)}}</td>-->
<!--                </tr>-->
<!--              </ng-container>-->



            </table>
        <button class="huge ui  button "  style="background-color:black;color:white"  (click)="slipDetail_Back_Button()"><i class="reply icon" style="position:relative;"></i><span style="position:relative;">{{"Back" | t}}</span></button>
</div>


    <div class="ui column" style="border-style:groove;background-color:white;overflow:auto" [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 64) + 'px','padding-top':'0px','padding-left':'5px','padding-right':'0px','padding-bottom':'0px','width':'510px','margin-left':'15px'}">

        <comp_cashoutdetail>
        </comp_cashoutdetail>
    </div>
</div>

<style>
    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #000000;
    }
</style>




